import i18n from 'typescript/application/i18n';
import styles from 'typescript/components/error_fallback.module.scss';

export const ERROR_FALLBACK_TEST_ID = 'error-fallback';

const FALLBACK_STRINGS = {
  title: 'Something went wrong',
  body: "We're sorry, but something unexpected happened. Please refresh the page to try again.",
  cta: 'Refresh page',
};

const getLabel = (key: 'title' | 'body' | 'cta'): string => {
  if (i18n.isInitialized) {
    return i18n.t(`error.boundary.${key}`);
  }
  return FALLBACK_STRINGS[key];
};

const ErrorFallback = () => {
  const onClick = () => {
    window.location.reload();
  };

  return (
    <div data-testid={ERROR_FALLBACK_TEST_ID} className={styles.errorFallback}>
      <div className={styles.errorContent}>
        <h3>{getLabel('title')}</h3>
        <p className="paragraph-20">{getLabel('body')}</p>
        <button
          type="button"
          className={styles.refreshButton}
          onClick={onClick}
        >
          {getLabel('cta')}
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
